import {
  AfterViewInit,
  Component,
  Input,
  OnInit,
  ViewChild,
} from '@angular/core';
import { environment } from 'src/environments/environment';
import { Gallery } from '../../utils/models/gallery';
@Component({
  selector: 'app-gallery-company',
  templateUrl: './gallery-company.component.html',
  styleUrls: ['./gallery-company.component.scss'],
})
export class GalleryCompanyComponent implements OnInit, AfterViewInit {
  @Input() galleryList: any[];
  @ViewChild('video') video: any;
  onPlay: boolean;
  constructor() {
    this.galleryList = [];
    this.onPlay = false;
  }
  ngAfterViewInit(): void {
    // console.log(this.video);
  }

  ngOnInit(): void {}

  playVideo(video: any) {
    if (!this.onPlay) {
      video.play();
      this.onPlay = true;
    } else {
      video.pause();
      this.onPlay = false;
    }
  }

  toggleMute(video: any) {
    video.muted = !video.muted;
  }

  log(event: number) {
    // setTimeout(() => {
    //   this.video.pause();
    // });
  }

  buildUrlGallery(service: Gallery): string {
    return 'https://tarjetasf.virtualplace.online/Empresas/Galeria/' + service.urlFile;
  }

  typeService(service: string): string {
    const tmp = service.split('.');
    const typeService = tmp[tmp.length - 1];
    switch (typeService) {
      case 'png':
      case 'jpg':
      case 'jpeg':
      case 'PNG':
      case 'JPG':
      case 'JPEG':
        return 'image';
        break;
      case 'mp4':
      case 'mvk':
      case 'avi':
      case 'mov':
      case 'MP4':
      case 'MVK':
      case 'AVI':
      case 'MOV':
        return 'video';
        break;
      default:
        return '';
        break;
    }
  }
}
